module.exports = __webpack_public_path__ + "img/momo_profile_back_btn.4a92260e.png";